class OilogicShare extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('.main-article__share-link');
    this.label = this.querySelector('.main-article__share-text');
    if (!this.button) return;

    /* Ships hidden from the server: the button only works with JS, so it
       only appears once this element upgrades. */
    this.removeAttribute('hidden');

    this.url = this.getAttribute('data-url') || window.location.href;
    this.title = this.getAttribute('data-title') || document.title;
    this.copiedText = this.getAttribute('data-copied') || 'Link copied';

    this.abort = new AbortController();
    this.button.addEventListener('click', this.onClick, { signal: this.abort.signal });
  }

  disconnectedCallback() {
    this.abort?.abort();
    clearTimeout(this.resetTimer);
  }

  onClick = async () => {
    if (navigator.share) {
      try {
        await navigator.share({ title: this.title, url: this.url });
        return;
      } catch (error) {
        if (error.name === 'AbortError') return;
      }
    }

    try {
      await navigator.clipboard.writeText(this.url);
      this.flashCopied();
    } catch (error) {
      window.prompt(this.copiedText, this.url);
    }
  };

  flashCopied() {
    if (!this.label) return;
    if (this.originalText == null) this.originalText = this.label.textContent;
    this.label.textContent = this.copiedText;
    clearTimeout(this.resetTimer);
    this.resetTimer = setTimeout(() => {
      this.label.textContent = this.originalText;
    }, 2000);
  }
}

if (!customElements.get('oilogic-share')) {
  customElements.define('oilogic-share', OilogicShare);
}
